import api from './client';

export const partnerApi = {
  getContent: () => api.get('/partner/content'),
};
